import * as R from 'ramda';
import { useLocation } from 'react-router-dom';
import { text } from '../components/common/Text';

export function parseJson(params) {
  try {
    return JSON.parse(params);
  } catch (error) {
    return error;
  }
}

export function getReviewEditTitle(edit)
{
    let title = '';
    if (edit) {
      title = text('common.close');
    } else {
      title = text('common.edit');
    }
    return title;
}

export function keyValueList(data, key) {
  const lov = x => ({ label: x, value: x });
  const label = x => x[key];
  return R.is(Array, data) ? R.compose(R.sortBy(R.prop('label')), R.map(lov), R.uniq(), R.map(label))(data) : [];
}

export function useQuery() {
  return new URLSearchParams(useLocation().search);
}
export function usePathName() {
  const location = useLocation();
  return location.pathname;
}
const yesNo = a => (a ? 'Yes' : 'No');
function replaceBool(a) {
  if (typeof a === 'boolean') {
    return yesNo(a);
  }
  if (typeof a === 'object' && a !== null) {
    return R.map(replaceBool, a);
  }
  return a;
}
export const transformBool = data => R.map(replaceBool, data);

export const getGAId = () => {
  const GACode = type => {
    try {
      return JSON.parse(process.env.REACT_APP_GA)[type];
    } catch (e) {
      return '';
    }
  };
  const websiteEnv = window.location.hostname;
  let gaTrackingId = '';
  if (websiteEnv.search('unit-') >= 0) {
    gaTrackingId = GACode('UNIT');
  } else if (websiteEnv.search('uat-') >= 0) {
    gaTrackingId = GACode('UAT');
  } else if (websiteEnv.search('ci-') >= 0 || websiteEnv.search('localhost') >= 0) {
    gaTrackingId = GACode('CI');
  } else if (websiteEnv.search('test-') >= 0) {
    gaTrackingId = GACode('TEST');
  } else {
    gaTrackingId = GACode('PROD');
  }
  return gaTrackingId;
};

export function replaceKeys(obj) {
  const newObj = {};
  Object.keys(obj).forEach(key => {
    const newKey = key.toUpperCase();
    newObj[newKey] = obj[key];
  });
  return newObj;
}

export const setIsEditingFlag = () => {
  document.body.setAttribute('data-is-editing', true);
};

export const removeIsEditingFlag = () => {
  document.body.removeAttribute('data-is-editing');
};
